import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  Product,
  ProductService,
} from 'src/app/services/product-service/product-service.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-delete-product-dialog',
  templateUrl: './delete-product-dialog.component.html',
  styleUrls: ['./delete-product-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent, MatDialogClose],
})
export class DeleteProductDialogComponent {
  private product = inject<Product>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<DeleteProductDialogComponent>>(MatDialogRef);
  private productService = inject(ProductService);

  async submit(): Promise<void> {
    try {
      await this.productService.deleteProduct(this.product);
      this.dialogRef.close(true);
    } catch {
      console.error('Error while deleting product');
    }
  }
}
